import React from 'react';
import { useTheme } from '../context/ThemeContext';

const ACCENT_PRESETS = [
    { name: 'Default', value: null }, // Null usage means revert to CSS default (white/black)
    { name: 'Blue', value: '#3b82f6' },
    { name: 'Purple', value: '#8b5cf6' },
    { name: 'Green', value: '#10b981' },
    { name: 'Pink', value: '#ec4899' },
    { name: 'Orange', value: '#f97316' }
];

const ColorPicker = () => {
    const { accentColor, setAccentColor } = useTheme();

    const cycleColor = () => {
        const currentIndex = ACCENT_PRESETS.findIndex(p => p.value === accentColor);
        const nextIndex = (currentIndex + 1) % ACCENT_PRESETS.length;
        setAccentColor(ACCENT_PRESETS[nextIndex].value);
    };

    return (
        <button className="theme-toggle" onClick={cycleColor} aria-label="Change Accent Color" title="Change Contrast Color">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"></path>
                <path d="M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10z" fill={accentColor || 'currentColor'} stroke="none" opacity={accentColor ? 1 : 0.3} ></path>
            </svg>
        </button>
    );
};

export default ColorPicker;
